<template>
    <div>
        <component
            v-show="show"
            :is="renderForm"
            v-model="isValid"
            ref="formInput"
            class="c-editable-cell with-details"
            @submit.prevent
        >
            <label class="text-sm text-black block mt-4 mb-2 text-center lg:text-left">{{label}}</label>
            <component
                outlined solo dense flat
                :is="renderEditableComponent"
                v-bind="config.vuetifyAttrs"
                :placeholder="config.placeholder"
                v-model="formInput.inputValue"
                :items="config.items"
                :rules="rules"
                @change="changeHandler"
            ></component>
        </component>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'TextareaAndLabel',
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: () => {}
        },
        rules: {
            type: Array,
            default: () => []
        },
        show: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            renderEditableComponent: 'v-textarea',
            renderForm: 'v-form',
            isValid: true,
            formInput: {inputValue: ''},
            defaultRules: [],
            defaultConfig: {},
            defaultValue: '',
        }
    },
    mounted() {
        this.formInput.inputValue = this.value || this.defaultValue
    },
    methods: {
        validate() {
            this.isValid = this.$refs.formInput.validate()
            return this.isValid
        },
        clearValidate(){
            this.isValid = true
            this.$refs.formInput.reset()
            return this.isValid
        },
        changeHandler() {
            if (!this.validate() && !this.isExternal && !this.formInput.inputValue) return
            this.$emit('input', this.formInput.inputValue)
            this.$emit('value-changed')
        }
    },
    computed: {
        ...mapGetters(['isExternal']),
        radioGroupConfig() {
            return this.config || this.defaultConfig
        },
    },
    watch: {
        value() {
            this.formInput.inputValue = this.value
        },
    }
}
</script>

